package org.teddapp.project.sync

// Fichier généré à partir du registre du noyau (core/tedd-core/src/model/entities.rs).
// Ne garde que les entités que l'application synchronise. À régénérer quand le registre change :
// le test « le registre embarqué suit celui du noyau » le rappelle.

internal enum class WireType { Uuid, Text, Int, Bool, Instant, Date, Json }

internal class WireField(val name: String, val type: WireType, val nullable: Boolean)

internal object SyncRegistry {
    private fun f(name: String, type: WireType, nullable: Boolean = false) = WireField(name, type, nullable)

    /** Les champs de chaque entité, par son nom côté serveur. */
    val fields: Map<String, List<WireField>> = mapOf(
        "user_profile" to listOf(
            f("fullname", WireType.Text),
            f("email", WireType.Text),
            f("avatar_url", WireType.Text),
            f("bio", WireType.Text),
            f("language", WireType.Text),
            f("theme_mode", WireType.Text),
            f("finance_default_period", WireType.Text),
            f("finance_default_currency", WireType.Text),
            f("pomodoro_focus_min", WireType.Int),
            f("pomodoro_short_break_min", WireType.Int),
            f("pomodoro_long_break_min", WireType.Int),
            f("notify_habits", WireType.Bool),
            f("notify_deadlines", WireType.Bool),
            f("notify_pomodoro_end", WireType.Bool),
            f("notify_budget_alerts", WireType.Bool),
            f("created_at", WireType.Instant),
        ),
        "organization" to listOf(
            f("name", WireType.Text),
            f("description", WireType.Text, true),
            f("color", WireType.Text),
            f("icon", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "category" to listOf(
            f("name", WireType.Text),
            f("color", WireType.Text),
            f("icon", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "finance_account" to listOf(
            f("name", WireType.Text),
            f("type", WireType.Text),
            f("currency", WireType.Text),
            f("opening_balance", WireType.Int),
            f("icon", WireType.Text),
            f("color", WireType.Text),
            f("bank", WireType.Text, true),
            f("last4", WireType.Text, true),
            f("low_threshold", WireType.Int, true),
            f("high_threshold", WireType.Int, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "finance_category" to listOf(
            f("name", WireType.Text),
            f("type", WireType.Text),
            f("icon", WireType.Text),
            f("color", WireType.Text),
            f("is_default", WireType.Bool),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "pomodoro_session" to listOf(
            f("date_start", WireType.Date),
            f("date_end", WireType.Date, true),
            f("status", WireType.Text),
            f("timer_minutes", WireType.Int),
            f("started_at", WireType.Instant),
            f("ended_at", WireType.Instant, true),
            f("created_at", WireType.Instant),
        ),
        "expense_list" to listOf(
            f("name", WireType.Text),
            f("description", WireType.Text, true),
            f("status", WireType.Text),
            f("date", WireType.Date, true),
            f("recurrence", WireType.Text),
            f("next_reset_date", WireType.Date, true),
            f("last_reset_date", WireType.Date, true),
            f("reset_mode", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "focus_session" to listOf(
            f("started_at", WireType.Instant),
            f("ended_at", WireType.Instant),
            f("focus_minutes", WireType.Int),
            f("break_minutes", WireType.Int),
            f("pomodoros", WireType.Int),
            f("task_id", WireType.Uuid, true),
            f("note", WireType.Text, true),
            f("skill_id", WireType.Uuid, true),
            f("created_at", WireType.Instant),
        ),
        "objective" to listOf(
            f("category_id", WireType.Uuid, true),
            f("title", WireType.Text),
            f("description", WireType.Text, true),
            f("motivation", WireType.Text, true),
            f("deadline", WireType.Date, true),
            f("year", WireType.Int, true),
            f("status", WireType.Text),
            f("progress", WireType.Int),
            f("skill_id", WireType.Uuid, true),
            f("step_id", WireType.Uuid, true),
            f("created_at", WireType.Instant),
        ),
        "project" to listOf(
            f("organization_id", WireType.Uuid),
            f("objective_id", WireType.Uuid, true),
            f("name", WireType.Text),
            f("description", WireType.Text, true),
            f("objectives", WireType.Text, true),
            f("color", WireType.Text),
            f("icon", WireType.Text),
            f("skill_id", WireType.Uuid, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "project_status" to listOf(
            f("project_id", WireType.Uuid),
            f("name", WireType.Text),
            f("color", WireType.Text),
            f("position", WireType.Text),
            f("is_terminal", WireType.Bool),
            f("created_at", WireType.Instant),
        ),
        "milestone" to listOf(
            f("objective_id", WireType.Uuid),
            f("title", WireType.Text),
            f("description", WireType.Text, true),
            f("deadline", WireType.Date, true),
            f("progress", WireType.Int),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "task" to listOf(
            f("parent_kind", WireType.Text),
            f("parent_id", WireType.Uuid, true),
            f("status_id", WireType.Uuid, true),
            f("title", WireType.Text),
            f("description", WireType.Text, true),
            f("status", WireType.Text),
            f("priority", WireType.Text, true),
            f("effort", WireType.Int, true),
            f("due_date", WireType.Date, true),
            f("estimated_minutes", WireType.Int, true),
            f("real_minutes", WireType.Int, true),
            f("recurrence", WireType.Text, true),
            f("pomodoro_pool_date", WireType.Date, true),
            f("position", WireType.Text),
            f("completed_at", WireType.Instant, true),
            f("kind", WireType.Text, true),
            f("deliverable", WireType.Text, true),
            f("acceptance", WireType.Text, true),
            f("created_at", WireType.Instant),
        ),
        "finance_transaction" to listOf(
            f("date", WireType.Date),
            f("account_id", WireType.Uuid),
            f("to_account_id", WireType.Uuid, true),
            f("cat_id", WireType.Uuid, true),
            f("type", WireType.Text),
            f("amount", WireType.Int),
            f("description", WireType.Text, true),
            f("fund_id", WireType.Uuid, true),
            f("verdict", WireType.Text, true),
            f("created_at", WireType.Instant),
        ),
        "expense_list_item" to listOf(
            f("list_id", WireType.Uuid),
            f("name", WireType.Text),
            f("planned", WireType.Int),
            f("actual", WireType.Int, true),
            f("cat_id", WireType.Uuid, true),
            f("is_done", WireType.Bool),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "pomodoro_item" to listOf(
            f("session_id", WireType.Uuid),
            f("source_type", WireType.Text),
            f("source_id", WireType.Uuid, true),
            f("custom_title", WireType.Text, true),
            f("priority", WireType.Int),
            f("position", WireType.Text),
            f("completed", WireType.Bool),
            f("completed_at", WireType.Instant, true),
            f("estimated_minutes", WireType.Int, true),
            f("created_at", WireType.Instant),
        ),
        "pomodoro_check" to listOf(
            f("item_id", WireType.Uuid),
            f("label", WireType.Text),
            f("note", WireType.Text, true),
            f("checked", WireType.Bool),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "notebook" to listOf(
            f("name", WireType.Text),
            f("icon", WireType.Text),
            f("color", WireType.Text),
            f("parent_id", WireType.Uuid, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "note" to listOf(
            f("parent_kind", WireType.Text),
            f("parent_id", WireType.Uuid, true),
            f("title", WireType.Text, true),
            f("body", WireType.Text),
            f("color", WireType.Text, true),
            f("is_pinned", WireType.Bool),
            f("is_favorite", WireType.Bool),
            f("tags", WireType.Json, true),
            f("attachments", WireType.Json, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "mind_map" to listOf(
            f("title", WireType.Text),
            f("color", WireType.Text, true),
            f("skill_id", WireType.Uuid, true),
            f("objective_id", WireType.Uuid, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "mind_map_node" to listOf(
            f("map_id", WireType.Uuid),
            f("parent_id", WireType.Uuid, true),
            f("text", WireType.Text),
            f("color", WireType.Text, true),
            f("source_kind", WireType.Text, true),
            f("source_id", WireType.Text, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "expense_entry" to listOf(
            f("item_id", WireType.Uuid),
            f("label", WireType.Text),
            f("amount", WireType.Int),
            f("date", WireType.Date, true),
            f("note", WireType.Text, true),
            f("tx_id", WireType.Uuid, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "simulation" to listOf(
            f("name", WireType.Text),
            f("note", WireType.Text, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "simulation_line" to listOf(
            f("simulation_id", WireType.Uuid),
            f("label", WireType.Text),
            f("expression", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "loan" to listOf(
            f("direction", WireType.Text),
            f("counterparty", WireType.Text),
            f("principal", WireType.Int),
            f("interest", WireType.Int),
            f("currency", WireType.Text),
            f("date", WireType.Date),
            f("due_date", WireType.Date, true),
            f("note", WireType.Text, true),
            f("account_id", WireType.Uuid, true),
            f("tx_id", WireType.Uuid, true),
            f("status", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "loan_payment" to listOf(
            f("loan_id", WireType.Uuid),
            f("amount", WireType.Int),
            f("date", WireType.Date),
            f("account_id", WireType.Uuid),
            f("tx_id", WireType.Uuid, true),
            f("note", WireType.Text, true),
            f("created_at", WireType.Instant),
        ),
        "skill_resource" to listOf(
            f("skill_id", WireType.Uuid),
            f("step_id", WireType.Uuid, true),
            f("origin", WireType.Text),
            f("format", WireType.Text),
            f("title", WireType.Text),
            f("url", WireType.Text, true),
            f("body", WireType.Text, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
            f("index_status", WireType.Text, true),
            f("index_error", WireType.Text, true),
            f("indexed_at", WireType.Instant, true),
            f("refresh_error", WireType.Text, true),
            f("reindex_requested_at", WireType.Instant, true),
            f("content_version", WireType.Int, true),
        ),
        "assistant_conversation" to listOf(
            f("skill_id", WireType.Uuid),
            f("title", WireType.Text, true),
            f("created_at", WireType.Instant),
            f("last_message_at", WireType.Instant, true),
        ),
        "assistant_message" to listOf(
            f("conversation_id", WireType.Uuid),
            f("role", WireType.Text),
            f("content", WireType.Text),
            f("sources", WireType.Json, true),
            f("status", WireType.Text),
            f("error_code", WireType.Text, true),
            f("created_at", WireType.Instant),
        ),
        "keychain" to listOf(
            f("name", WireType.Text),
            f("icon", WireType.Text),
            f("color", WireType.Text),
            f("wrapped_key", WireType.Text),
            f("kdf", WireType.Json),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "keychain_item" to listOf(
            f("keychain_id", WireType.Uuid),
            f("payload", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "attachment" to listOf(
            f("owner_kind", WireType.Text),
            f("owner_id", WireType.Uuid),
            f("file_name", WireType.Text),
            f("mime_type", WireType.Text),
            f("size_bytes", WireType.Int),
            f("storage_key", WireType.Text, true),
            f("sha256", WireType.Text, true),
            f("width", WireType.Int, true),
            f("height", WireType.Int, true),
            f("status", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "mind_map_node_note" to listOf(
            f("node_id", WireType.Uuid),
            f("note_id", WireType.Uuid),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "skill" to listOf(
            f("name", WireType.Text),
            f("color", WireType.Text),
            f("icon", WireType.Text),
            f("intention", WireType.Text, true),
            f("target_hours", WireType.Int),
            f("tags", WireType.Json, true),
            f("pinned", WireType.Bool),
            f("deadline", WireType.Date, true),
            f("archived", WireType.Bool),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "parcours_step" to listOf(
            f("skill_id", WireType.Uuid),
            f("code", WireType.Text),
            f("kind", WireType.Text),
            f("position", WireType.Int),
            f("title", WireType.Text),
            f("summary", WireType.Text, true),
            f("planned_min", WireType.Int),
            f("level_name", WireType.Text, true),
            f("level_desc", WireType.Text, true),
            f("project_id", WireType.Uuid, true),
            f("created_at", WireType.Instant),
        ),
        "asset" to listOf(
            f("name", WireType.Text),
            f("kind", WireType.Text),
            f("currency", WireType.Text),
            f("value", WireType.Int, true),
            f("purchase_price", WireType.Int, true),
            f("acquired_date", WireType.Date, true),
            f("valued_at", WireType.Date, true),
            f("note", WireType.Text, true),
            f("archived", WireType.Bool),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "asset_valuation" to listOf(
            f("asset_id", WireType.Uuid),
            f("date", WireType.Date),
            f("value", WireType.Int),
            f("note", WireType.Text, true),
            f("created_at", WireType.Instant),
        ),
        "flashcard" to listOf(
            f("skill_id", WireType.Uuid, true),
            f("front", WireType.Text),
            f("back", WireType.Text),
            f("note", WireType.Text, true),
            f("box", WireType.Int),
            f("due_date", WireType.Date),
            f("last_review", WireType.Date, true),
            f("reviews", WireType.Int),
            f("lapses", WireType.Int),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
            f("deck_id", WireType.Uuid, true),
        ),
        "objective_reflection" to listOf(
            f("objective_id", WireType.Uuid),
            f("text", WireType.Text),
            f("missed_deadline", WireType.Date, true),
            f("attempt", WireType.Int, true),
            f("created_at", WireType.Instant),
        ),
        "craving_observation" to listOf(
            f("habit", WireType.Text),
            f("date", WireType.Date),
            f("sensations", WireType.Text),
            f("zones", WireType.Text),
            f("intensity", WireType.Int),
            f("outcome", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "timer_state" to listOf(
            f("running", WireType.Bool),
            f("started_at", WireType.Instant, true),
            f("planned_minutes", WireType.Int),
            f("item_id", WireType.Uuid, true),
            f("skill_id", WireType.Uuid, true),
            f("paused_at", WireType.Instant, true),
            f("paused_accum_ms", WireType.Int),
            f("device", WireType.Text, true),
            f("created_at", WireType.Instant),
        ),
        "competence_family" to listOf(
            f("name", WireType.Text),
            f("description", WireType.Text, true),
            f("color", WireType.Text),
            f("icon", WireType.Text),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "competence" to listOf(
            f("family_id", WireType.Uuid),
            f("skill_id", WireType.Uuid, true),
            f("name", WireType.Text),
            f("description", WireType.Text, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "competence_criterion" to listOf(
            f("competence_id", WireType.Uuid),
            f("label", WireType.Text),
            f("description", WireType.Text, true),
            f("level", WireType.Int),
            f("evaluated_at", WireType.Instant, true),
            f("evaluation_note", WireType.Text, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "portfolio_piece" to listOf(
            f("title", WireType.Text),
            f("subtitle", WireType.Text, true),
            f("body", WireType.Text),
            f("links", WireType.Json, true),
            f("images", WireType.Json, true),
            f("date_start", WireType.Date, true),
            f("date_end", WireType.Date, true),
            f("project_id", WireType.Uuid, true),
            f("step_id", WireType.Uuid, true),
            f("status", WireType.Text),
            f("pinned", WireType.Bool),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
        "portfolio_piece_competence" to listOf(
            f("piece_id", WireType.Uuid),
            f("competence_id", WireType.Uuid),
            f("criterion_id", WireType.Uuid, true),
            f("note", WireType.Text, true),
            f("position", WireType.Text),
            f("created_at", WireType.Instant),
        ),
    )
}
